import { ComponentProps } from 'react'
import {
  FieldValues,
  Path,
  PathValue,
  UseControllerProps,
  useController,
} from 'react-hook-form'
import { Listbox, FormGroup } from '@tovala/component-library'

type ListboxStyle = ComponentProps<typeof Listbox>['listboxStyle']

export type FormListboxRHFProps<T extends FieldValues> = {
  label?: string
  listboxStyle?: ListboxStyle
  id: string
} & Omit<
  ComponentProps<typeof Listbox>,
  'hasError' | 'label' | 'onChange' | 'value'
> &
  UseControllerProps<T>

const FormListboxRHF = <T extends FieldValues>({
  control,
  defaultValue,
  label,
  name,
  rules,
  ...rest
}: FormListboxRHFProps<T>) => {
  const {
    field,
    fieldState: { error, isTouched },
  } = useController({
    name,
    control,
    defaultValue,
    rules,
  })

  const hasError = !!(error && !isTouched)

  return (
    <FormGroup error={error?.message} label={label} labelFor={field.name}>
      <Listbox
        {...field}
        {...rest}
        hasError={hasError}
        onChange={(option) => {
          const optionValue = option as PathValue<T, Path<T>>
          field.onChange(optionValue)
        }}
      />
    </FormGroup>
  )
}

export default FormListboxRHF
